import { useTranslation } from 'next-i18next'

import appConfig from '~/config/app'
import IconButton from '~/bootcamp/components/IconButton'
import ROUTES from '~/shared/constants/routes.const'

import { selectBootcampPageHelp } from '~/bootcamp/slices/bootcamp-page.slice'
import { useAppSelector } from '~/redux/hooks'

const buttonClassName = 'w-full text-xs !py-0.5 -ml-1'

const OtherResources = (): React.ReactElement => {
  const { t } = useTranslation(['bootcamp', 'menu'])
  const help = useAppSelector(selectBootcampPageHelp)

  return (
    <ul className="space-y-1">
      {help?.encyclopediaPath && (
        <li>
          <IconButton
            className={buttonClassName}
            iconHeight={52}
            iconSrcKey="icons/btn_enclyopedia_shadow.png"
            iconWidth={61}
            link={help.encyclopediaPath}
            title={t('menu:encyclopedia')}
          />
        </li>
      )}
      {help?.drillPath && (
        <li>
          <IconButton
            className={buttonClassName}
            iconHeight={37}
            iconSrcKey="icons/btn_essentials_shadow.png"
            iconWidth={59}
            link={help.drillPath}
            title={t('menu:drillhefter')}
          />
        </li>
      )}
      {!appConfig.isSchoolPlatform && (
        <li>
          <IconButton
            className={buttonClassName}
            iconClassName="shadow-rounded-button rounded-full"
            iconHeight={80}
            iconSrcKey="icons/tutoring-stroke.png"
            iconWidth={80}
            link={ROUTES.BOOKING}
            title={t('bootcamp:tutoring')}
          />
        </li>
      )}
    </ul>
  )
}

export default OtherResources
